/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Restore_DownloadInputs */



/**
* | output |
* | --- |
* | "Download copy" |
*
* @param {Assistant_Restore_DownloadInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_restore_download = /** @type {((inputs?: Assistant_Restore_DownloadInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Restore_DownloadInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Télécharger la copie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kopie herunterladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica la copia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скачать копию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargar copia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下载副本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ダウンロード版")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डाउनलोड कॉपी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Baixar cópia")
	return /** @type {LocalizedString} */ ("Download copy")
});